'use strict';

exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var map = function map(obj, cb) {
  for (var key in obj) {
    if (!Object.prototype.hasOwnProperty.call(obj, key)) {
      continue;
    }
    var value = obj[key];
    try {
      // If the callback returns true, that is a signal to stop iteration (short circuit search)
      if (cb(key, value)) {
        // eslint-disable-line callback-return
        return obj;
      }
    } catch (e) {
      // Ignore return value
    }
  }
  return obj;
};

var merge = function merge() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var result = {};
  for (var i = 0; i < args.length; i++) {
    var obj = args[i];
    if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object') {
      map(obj, function (key, value) {
        result[key] = value;
      });
    }
  }
  return result;
};

var removeUndefined = function removeUndefined(kvPair) {
  // strip out undefined properties
  for (var prop in kvPair) {
    if (typeof kvPair[prop] === 'undefined') {
      delete kvPair[prop];
    }
  }
};

var parseValue = function parseValue(kvPair) {
  if (kvPair.length === 2) {
    return kvPair[1];
  }
  return undefined;
};

// pairDelim - delimiter that separates each KVP. ('&' in plid=1&shopperId=123)
// equalityDelim - delimiter that separates the key from the value. ('=' in plid=1&shopperId=123)
var parseString = function parseString(string, pairDelim, equalityDelim) {
  if (typeof string !== 'string') {
    return {};
  }
  var result = {};
  var split = string.split(pairDelim);
  for (var i = 0; i < split.length; i++) {
    var kvPair = split[i].split(equalityDelim);
    result[kvPair[0]] = parseValue(kvPair);
  }
  return result;
};

var stringify = function stringify(obj, pairDelim, equalityDelim) {
  var resultList = [];
  map(obj, function (key, value) {
    resultList.push('' + key + equalityDelim + value);
  });
  if (resultList.length === 0) {
    return '';
  }
  return resultList.join(pairDelim);
};

/**
 * @param {Object} obj - Json object that needs cleaned
 * @param {String} pattern - pattern to clean in key name
 * @param {String} replacement - if a pattern match is found, the match will be
 *                               replaced with this value. If not provided, the
 *                               match will be removed.
 * @returns {undefined}
 */
var cleanKeyNames = function cleanKeyNames(obj, pattern, replacement) {
  if (!obj || !pattern) return;

  map(obj, function (key, value) {
    var newKey = (key + '').split(pattern).join(replacement || '');

    delete obj[key];
    obj[newKey] = value;
  });
};

exports.cleanKeyNames = cleanKeyNames;
exports.map = map;
exports.merge = merge;
exports.parseString = parseString;
exports.parseValue = parseValue;
exports.stringify = stringify;
exports.removeUndefined = removeUndefined;